import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UsersInfo } from '../../interfaces/user.interface';

@Injectable({
  providedIn: 'root',
})
export class RegisterService {
  constructor(private http: HttpClient) {}

  validateEmail(url: string, email: string): Observable<any> {
    return this.http.get(`${url}/users/params/validation?_email=${email}`);
  }
  sendEmailOtp(url: string, email: string): Observable<any> {
    return this.http.post(`${url}/otp/generation`, {
      address: email,
      type: 'email',
    });
  }
  validateEmailOtp(url: string, email: string, code: string): Observable<any> {
    return this.http.post(`${url}/otp/verification`, {
      address: email,
      code,
    });
  }
  validateUsername(url: string, username: string): Observable<any> {
    return this.http.post(
      `${url}/users/data/verification`,
      {
        username,
      }
    );
  }
  validatePhone(url: string, phone: string): Observable<any> {
    return this.http.get(`${url}/users/params/validation?_phone=${phone}`);
  }
  register(url: string, user: UsersInfo): Observable<{ data: UsersInfo }> {
    return this.http.post<{ data: UsersInfo }>(`${url}/users`, user);
  }
  completeRegister(
    url: string,
    user: UsersInfo,
    token: string
  ): Observable<{ data: UsersInfo }> {
    return this.http.post<{ data: UsersInfo }>(
      `${url}/complete/registration/${token}`,
      user
    );
  }
}
